<template>
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-10">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent pb-5">
          <div class="btn-wrapper text-center">
            <p></p>
          </div>
        </div>
        <div class="card-body px-lg-12 py-lg-12">
          <h3>COOKIES</h3>

          <p>
            En esta web recopilamos y utilizamos la información según indicamos
            en la
            <router-link to="/politica_privacidad">
              Política de Privacidad.
            </router-link>
          </p>

          <p>
            Una de las formas en las que recopilamos información es a través del
            uso de la tecnología llamada “cookies”
          </p>

          <p>
            La presente política de cookies tiene por finalidad informarle de
            manera clara y precisa sobre las cookies que se utilizan en la
            página web de Gymtrao.
          </p>

          <h4>¿Por qué tenemos esta página sobre cookies?</h4>

          <p>
            La LSSI-CE, obliga a todos los que tenemos un blog o una web a
            advertir al usuario de la existencia de cookies, informar sobre
            ellas y requerirle permiso para descargarlas.
          </p>

          <p>
            Artículo 22.2 de la Ley 34/2002. “Los prestadores de servicios
            podrán utilizar dispositivos de almacenamiento y recuperación de
            datos en equipos terminales de los destinatarios, a condición de que
            los mismos hayan dado su consentimiento después de que se les haya
            facilitado información clara y completa sobre su utilización, en
            particular, sobre los fines del tratamiento de los datos, con
            arreglo a lo dispuesto en la Ley Orgánica 15/1999, de 13 de
            diciembre, de Protección de Datos de Carácter Personal”.
          </p>

          <p>
            Queremos cumplir con el máximo rigor el artículo 22.2 el de la Ley
            34/2002 de Servicios de la Sociedad de la Información y Comercio
            Electrónico referente a las cookies, no obstante, teniendo en cuenta
            la forma en la que funciona Internet y los sitios web, no siempre es
            posible contar con información actualizada de las cookies que
            terceras partes puedan utilizar a través de este sitio web.
          </p>

          <p>
            Esto se aplica especialmente a casos en los que esta página web
            contiene elementos integrados: es decir, textos, vídeos, documentos
            o imágenes que se almacenan en otra parte, pero se muestran en
            nuestro sitio web.
          </p>

          <p>
            Por consiguiente, en caso de que te encuentres con este tipo de
            cookies en este sitio web y no estén enumeradas en la lista
            siguiente, te rogamos que nos lo comuniques. También puedes ponerte
            en contacto directamente con el tercero para pedirle información
            sobre las cookies que coloca, la finalidad y la duración de la
            cookie, y cómo ha garantizado su privacidad.
          </p>

          <p>Vamos poco a poco.</p>

          <h5>¿Qué es una cookie?</h5>

          <p>
            Una cookie es un fichero inofensivo que se descarga en tu ordenador
            al acceder a determinadas páginas web. Las cookies permiten a una
            página web, entre otras cosas, almacenar y recuperar información
            sobre los hábitos de navegación de un usuario o de su equipo y,
            dependiendo de la información que contengan y de la forma en que
            utilice su equipo.
          </p>

          <p>
            Así, hay cookies que obtienen información relacionada con el número
            de páginas visitadas, la ciudad a la que está asignada la dirección
            IP desde la que se accede, el número de nuevos usuarios, la
            frecuencia y reincidencia de las visitas, el tiempo de visita, el
            navegador, el operador o el tipo de terminal desde el que se realiza
            la visita.
          </p>

          <h5>¿Qué NO ES una cookie?</h5>

          <p>
            No es un virus, ni un troyano, ni un gusano, ni spam, ni spyware, ni
            abre ventanas pop-up. Puedes dormir tranquilo.
          </p>

          <h5>¿Qué información almacena una cookie?</h5>

          <p>
            Las cookies no suelen almacenar información sensible sobre ti, como
            tarjetas de crédito o datos bancarios, fotografías, tu DNI o
            información personal, etc. Los datos que guardan son de carácter
            técnico, preferencias personales, personalización de contenidos,
            etc.
          </p>

          <p>
            El servidor web no te asocia como persona si no a tu navegador web.
            De hecho, si navegas habitualmente con Internet Explorer y pruebas a
            navegar por la misma web con Firefox o Chrome verás que la web no se
            da cuenta que eres la misma persona porque en realidad está
            asociando al navegador, no a la persona.
          </p>

          <h5>¿Qué ocurre si desactivo las cookies?</h5>

          <p>
            Para que entiendas el alcance que puede tener desactivar las cookies
            te mostramos unos ejemplos:
          </p>

          <ul>
            No podrás compartir contenidos de esa web en Facebook, Twitter o
            cualquier otra red social. El sitio web no podrá adaptar los
            contenidos a tus preferencias personales, como suele ocurrir en las
            tiendas online. No podrás acceder al área personal de la web, como
            por ejemplo Mi cuenta, o Mi perfil o Mis pedidos. Tiendas online: Te
            será imposible realizar compras online, tendrán que ser telefónicas
            o visitando la tienda física si es que dispone de ella. No será
            posible personalizar tus preferencias geográficas como franja
            horaria, divisa o idioma. El sitio web no podrá realizar analíticas
            web sobre visitantes y tráfico en la web, lo que dificultará que la
            web sea competitiva. No podrás escribir, no podrás subir fotos,
            publicar comentarios, valorar o puntuar contenidos. La web tampoco
            podrá saber si eres un humano o una aplicación automatizada que
            publica spam. No se podrá mostrar publicidad sectorizada, lo que
            reducirá los ingresos publicitarios de la web. Todas las redes
            sociales usan cookies, si las desactivas no podrás utilizar ninguna
            red social.
          </ul>

          <h5>¿Qué tipos de cookies hay?</h5>

          <p>
            Tipos de cookies según la entidad que gestione el equipo o dominio
            desde donde se envían las cookies y trate los datos que se obtengan,
            podemos distinguir:
          </p>

          <ul>
            Cookies propias: Son aquéllas que se envían al equipo terminal del
            usuario desde un equipo o dominio gestionado por el propio editor y
            desde el que se presta el servicio solicitado por el usuario.
            Cookies de terceros: Son aquéllas que se envían al equipo terminal
            del usuario desde un equipo o dominio que no es gestionado por el
            editor, sino por otra entidad que trata los datos obtenidos través
            de las cookies.
          </ul>

          <p>
            En el caso de que las cookies sean instaladas desde un equipo o
            dominio gestionado por el propio editor pero la información que se
            recoja mediante éstas sea gestionada por un tercero, no pueden ser
            consideradas como cookies propias.
          </p>

          <p>
            Es decir, las cookies propias son las generadas por la página que
            estás visitando y las de terceros son las generadas por servicios o
            proveedores externos como Mailchimp, Mailrelay, Facebook, Twitter,
            Google Adsense, etc.
          </p>

          <p>Según su utilidad:</p>

          <ul>
            Cookies técnicas: Son las más elementales y permiten, entre otras
            cosas, saber cuándo está navegando un humano o una aplicación
            automatizada, cuándo navega un usuario anónimo y uno registrado,
            tareas básicas para el funcionamiento de cualquier web dinámica.
            Cookies de análisis: Recogen información sobre el tipo de navegación
            que está realizando, las secciones que más utiliza, productos
            consultados, franja horaria de uso, idioma, etc. Cookies
            publicitarias: Muestran publicidad en función de su navegación, su
            país de procedencia, idioma, etc
          </ul>

          <p>
            Además, los navegadores pueden también permitir a los usuarios ver y
            borrar cookies individualmente.
          </p>

          <p>
            Dispones de más información sobre las Cookies en:
            <a href="https://es.wikipedia.org/wiki/Cookie">Wikipedia</a>
          </p>

          <h5>Web Beacons</h5>

          <p>
            Este sitio puede albergar también web beacons (también conocidos
            como web bugs). Los web beacons suelen ser pequeñas imágenes de un
            pixel por un pixel, visibles o invisibles colocados dentro del
            código fuente de las páginas web de un sitio. Los web beacons sirven
            y se utilizan de una forma similar a las cookies. Además, los web
            beacons suelen utilizarse para medir el tráfico de usuarios que
            visitan una página web y poder sacar un patrón de los usuarios de un
            sitio.
          </p>

          <p>
            Dispones de más información sobre los web beacons en:
            <a href="https://es.wikipedia.org/wiki/Web_bug">Wikipedia</a>
          </p>

          <h5>Cookies de terceros</h5>

          <p>
            En algunos casos, compartimos información sobre los visitantes de
            este sitio de forma anónima o agregada con terceros como puedan ser
            anunciantes, patrocinadores o auditores con el único fin de mejorar
            nuestros servicios. Todas estas tareas de procesamiento serán
            reguladas según las normas legales y se respetarán todos sus
            derechos en materia de protección de datos conforme a la regulación
            vigente.
          </p>

          <p>
            Este sitio mide el tráfico con diferentes soluciones que pueden
            utilizar cookies o web beacons para analizar lo que sucede en
            nuestras páginas. Actualmente utilizamos las siguientes soluciones
            para la medición del tráfico de este sitio. Puedes ver más
            información sobre la política de privacidad de cada una de las
            soluciones utilizadas para tal efecto:
          </p>

          <ul>
            <li>
              <a
                href="https://www.google.com/intl/es/policies/privacy/partners/"
                >Cómo usa Google los datos que recopila en los sitios web
                Google</a
              >
            </li>
            <li>
              (Analytics):
              <a href="https://www.google.com/intl/es_ALL/privacypolicy.html"
                >Política de Privacidad de Google Analytics</a
              >
              (si lo deseas puedes inhabilitar el seguimiento de Google
              Analytics mediante
              <a href="https://tools.google.com/dlpage/gaoptout"
                >este complemento para el navegador ofrecido por Google</a
              >
              )
            </li>
          </ul>

          <p>
            Este sitio también puede albergar publicidad propia, de afiliados, o
            de redes publicitarias. Esta publicidad se muestra mediante
            servidores publicitarios que también utilizan cookies para mostrar
            contenidos publicitarios afines a los usuarios. Cada uno de estos
            servidores publicitarios dispone de su propia política de
            privacidad, que puede ser consultada en sus propias páginas web.
          </p>

          <h4>¿Qué cookies utilizamos?</h4>

          <p>Cookies propias</p>

          <p>
            Inicio de sesión: Las cookies para iniciar sesión te permiten entrar
            y salir de tu cuenta de Gymtrao.
          </p>

          <p>
            Personalización: Las cookies ayudan a recordar con qué personas o
            sitios web has interactuado, para que pueda mostrarte contenido
            relacionado.
          </p>

          <p>
            Preferencias: Las cookies nos permiten recordar tus ajustes y
            preferencias, como el idioma preferido y tu configuración de
            privacidad.
          </p>

          <p>
            Seguridad: Utilizamos cookies para evitarte riesgos de seguridad.
            Principalmente para detectar cuándo alguien está intentando piratear
            tu cuenta.
          </p>

          <p>Entrando en más detalle:</p>

          <ul>
            <li>Cookie de entrada del usuario</li>
            <li>
              Cookie de sesión de autenticación o identificación del usuario
            </li>
            <li>Cookie de seguridad del usuario</li>
            <li>Cookie de sesión de reproductor multimedia</li>
            <li>Cookie de personalización de la interfaz de usuario</li>
            <li>
              Cookie de complemento (plug-in) para compartir e intercambiar
              contenidos sociales (Facebook y twitter)
            </li>
            <li>Cookie de sesión para equilibrar la carga</li>
          </ul>

          <p>
            Otra de las cookies que se descargan es una cookie de tipo técnico
            denominada JSESSIONID. Esta cookie permite almacenar un
            identificador único por sesión a través del que es posible vincular
            datos necesarios para posibilitar la navegación en curso.
          </p>

          <p>
            Por último, se descarga una cookie denominada show_cookies, propia,
            de tipo técnico y de sesión. Gestiona el consentimiento del usuario
            para el uso de las cookies en la página web, con el objeto de
            recordar aquellos usuarios que las han aceptado y aquellos que no,
            de modo que a los primeros no se les muestre información en la parte
            superior de la página al respecto.
          </p>

          <p>
            A continuación, y según exige el artículo 22.2 de la LSSI se
            detallan las cookies que pueden instalarse habitualmente durante la
            navegación por este sitio web
          </p>

          <table style="width: 100%">
            <tr>
              <th>NOMBRE</th>
              <th>DURACIÓN</th>
              <th>FINALIDAD</th>
            </tr>
            <tr>
              <td>Propia: Sesión tve_leads_unique</td>
              <td>Caduca al finalizar sesión</td>
              <td>
                Almacenan información del usuario y sus sesiones para mejorar la
                experiencia de usuario
              </td>
            </tr>
            <tr>
              <td>Terceros persistente _ga</td>
              <td>2 años a partir de la configuración</td>
              <td>
                Se usa para distinguir a los usuarios. Es una cookie
                perteneciente a Google Analytics. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente _gat</td>
              <td>10 minutos</td>
              <td>
                Se usa para saber el ratio de recarga. Es una cookie
                perteneciente a Google Analytics. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente __utma</td>
              <td>2 años desde cada actualización</td>
              <td>
                Esta cookie se suele establecer durante la primera visita. Si la
                cookie es eliminada manualmente, volverá a establecerse en la
                siguiente visita con ID nuevo. En la mayoría de los casos esta
                cookie se utiliza para determinar visitantes únicos a nuestro
                sitio y es actualizada con cada página vista. Además esta cookie
                tiene un ID único de Google Analytics que asegura tanto la
                validez de la misma como su accesibilidad como una medida de
                seguridad adicional. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente __utmb</td>
              <td>2 años desde cada actualización</td>
              <td>
                Esta cookie se utiliza para establecer y continuar una sesión de
                usuario en nuestro sitio. Cuando un usuario visita una página en
                nuestro sitio, el código de Google Analytics intenta actualizar
                esta cookie. Si no encuentra la cookie, creará una nueva. Cada
                vez que el usuario visita una página distinta se actualiza esta
                cookie para caducar a los 30 minutos, de esa forma continúa
                encontrar una sesión única en intervalos de 30 minutos. Esta
                cookie caduca cuando un usuario deja de visitas nuestro sitio
                por un período de 30 minutos. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>
                Terceros persistente APISID, HSID, NID, SAPISID, SID, SSID
              </td>
              <td>2 años desde su instalación</td>
              <td>
                Guarda preferencias de usuario y otra información de los
                servicios de Google que tiene el usuario. <a href="https://www.google.com/policies/privacy/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente __utmt</td>
              <td>De sesión</td>
              <td>
                Historicamente, esta cookie operaba junto con la cookie __utmb
                para determinar si se debía establecer una nueva sesión al
                usuario. Hoy en día no se utiliza pero sigue aquí para mantener
                compatibilidad hacia atrás con el código de theurchin.js y
                ga.js. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente __utmz</td>
              <td>6 meses desde cada actualización</td>
              <td>
                Esta cookie guarda información de referencias utilizadas por el
                visitante para llegar a nuestro sitio, ya sea de forma directa,
                un link de referencia, una búsqueda web o una campaña de
                publicidad o por email. Se utiliza para calcular el tráfico
                proviniente de buscadores web, campañas de marketing y
                navegación por nuestro sitio. Esta cookie se actualiza en cada
                vista de página. <a href="https://www.google.com/intl/es/policies/">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Propia persistente __cfduid</td>
              <td>5 años</td>
              <td>
                La cookie __ cfduid se utiliza para anular las restricciones de
                seguridad basadas en la dirección IP del visitante está
                viniendo. <a href="https://support.cloudflare.com/hc/en-us/articles/200170156-What-does-the-CloudFlare-cfduid-cookie-do">Más información</a> 
              </td>
            </tr>

            <tr>
              <td>Propia __smVID</td>
              <td>Caduca al finalizar la sesión</td>
              <td>
                Almacena información del usuario y sus sesiones para mejorar la
                experiencia de usuario.
              </td>
            </tr>
            <tr>
              <td>_remember_checked_on</td>
              <td>Caduca al finalizar la sesión</td>
              <td>Cookies con funcionalidades de Twitter.</td>
            </tr>
            <tr>
              <td>Terceros __stripe_mid</td>
              <td>Caduca al finalizar la sesión</td>
              <td>Cookie de Stripe. <a href="https://stripe.com/cookies-policy/legal">Más información</a> </td>
            </tr>
            <tr>
              <td>Terceros persistente pl</td>
              <td>90 días</td>
              <td>
                Se utiliza para registrar que un dispositivo o un navegador
                iniciaron sesión a través de la plataforma de Facebook. <a href="https://www.facebook.com/policy/cookies/printable">Más
                información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente fr</td>
              <td>90 días</td>
              <td>
                Se trata de la cookie de publicidad principal de Facebook. Se
                utiliza para ofrecer, analizar y mejorar la relevancia de los
                anuncios. <a href="https://www.facebook.com/policy/cookies/printable">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente sb</td>
              <td>2 años desde su instalación</td>
              <td>
                Cookie de Facebook que identifica al navegador con fines de
                autenticación del inicio de sesión. <a href="https://www.facebook.com/policy/cookies/printable">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente c_user</td>
              <td>20 días desde su instalación</td>
              <td>
                Se utiliza junto con la cookie xs para autenticar tu identidad
                en Facebook. <a href="https://www.facebook.com/policy/cookies/printable">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente xs</td>
              <td>90 días desde su instalación</td>
              <td>
                Se utiliza junto con la cookie c_user para autenticar tu
                identidad en Facebook. <a href="https://www.facebook.com/policy/cookies/printable">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>Terceros persistente datr</td>
              <td>2 años desde su instalación</td>
              <td>
                De Facebook que identifica a los navegadores con fines de
                seguridad e integridad del sitio, entre ellos, la recuperación
                de cuentas y la identificación de cuentas que puedan estar en
                riesgo. <a href="https://www.facebook.com/policy/cookies/printable">Más información</a> 
              </td>
            </tr>
            <tr>
              <td>doubleclick.com, DSIS- IDE-ID</td>
              <td>30 días</td>
              <td>
                Esta cookie se utiliza para volver a la focalización, la
                optimización, la presentación de informes y la atribución de
                anuncios en línea. DoubleClick envía una cookie al navegador
                después de cualquier impresión, clic u otra actividad cuyo
                resultado sea una llamada al servidor de DoubleClick. Si el
                navegador acepta la cookie, esta se almacena en él]
              </td>
            </tr>
          </table>

          <p>Cookies de terceros.</p>

          <p>
            Esta web utiliza servicios de análisis, concretamente, Google
            Analytics para ayudar al website a analizar el uso que hacen los
            usuarios del sitio web y mejorar la usabilidad del mismo, pero en
            ningún caso se asocian a datos que pudieran llegar a identificar al
            usuario. Google Analytics, es un servicio analítico de web prestado
            por Google, Inc.,
          </p>

          <p>
            Recogemos información relativa al número de usuarios que acceden a
            la web, el número de páginas vistas, la frecuencia y repetición de
            las visitas, su duración, el navegador utilizado, el operador que
            presta el servicio, el idioma, el terminal que utiliza y la ciudad a
            la que está asignada su dirección IP. Información que posibilita un
            mejor y más apropiado servicio por parte de este portal.
          </p>

          <p>
            Para garantizar el anonimato, Google convertirá su información en
            anónima truncando la dirección IP antes de almacenarla, de forma que
            Google Analytics no se usa para localizar o recabar información
            personal identificable de los visitantes del sitio. Google solo
            podrá enviar la información recabada por Google Analytics a terceros
            cuanto esté legalmente obligado a ello. Con arreglo a las
            condiciones de prestación del servicio de Google Analytics, Google
            no asociará su dirección IP a ningún otro dato conservado por
            Google.
          </p>

          <p>
            El usuario puede consultar <a href="https://www.google.es/intl/es/policies/technologies/types/">aquí </a> el tipo de cookies utilizadas por
            Google.
          </p>

          <p>
            Gymtrao es usuario de la plataforma de suministro y alojamiento de
            código Firebase, propiedad de la empresa norteamericana Google, Inc.
            A tales efectos, los usos de tales cookies por los sistemas nunca
            están bajo control o gestión del responsable de la web, pueden
            cambiar su función en cualquier momento, y entrar cookies nuevas.
            Estas cookies tampoco reportan al responsable de esta web beneficio
            alguno. Google, Inc., utiliza además otras cookies con la finalidad
            de ayudar a identificar y rastrear a los visitantes de los sitios de
            Firebase, conocer el uso que hacen del sitio web de Google, así como
            sus preferencias de acceso al mismo, tal y como se recoge en el
            apartado “Cookies” de su política de privacidad.
          </p>

          <p>
            Las cookies de redes sociales pueden almacenarse en su navegador
            mientras navega por https://gymtrao.com por ejemplo, cuando utiliza
            el botón de compartir contenidos de https://gymtrao.com en alguna
            red social.
          </p>

          <p>
            A continuación tienes información sobre las cookies de las redes
            sociales que utiliza esta web en sus propias políticas de cookies:
          </p>

          <ul>
            <li>
              Cookies de Facebook, ver <a href="https://app.innoit.net/lopd/imprimirPoliticaCookies.action?modo=1">más información</a>  en su política de cookies
            </li>
            <li>
              Cookies de Twitter, ver <a href="https://app.innoit.net/lopd/imprimirPoliticaCookies.action?modo=1"> más información</a> en su política de cookies
            </li>
            <li>
              Cookies de Instagram, ver <a href="https://app.innoit.net/lopd/imprimirPoliticaCookies.action?modo=1"> más información</a> en su política de
              cookies
            </li>
            <li>
              Cookies de Linkedin, ver <a href="https://app.innoit.net/lopd/imprimirPoliticaCookies.action?modo=1"> más información</a> en su política de cookies
            </li>
            <li>
              Cookies de Youtube, ver <a href="https://app.innoit.net/lopd/imprimirPoliticaCookies.action?modo=1"> más información</a> en su política de cookies
            </li>
          </ul>

          <p>
            Llevo a cabo acciones de remarketing mediante Google AdWords, que
            utiliza las cookies para ayudarme a ofrecer anuncios en línea
            específico basado en visitas anteriores a mi sitio web. Google
            utiliza esta información para mostrar anuncios en varios sitios web
            de terceros a través de Internet. Estas cookies están a punto de
            expirar y no contienen información que pueda identificarle
            personalmente. Por favor dirígete a la <a href="https://www.google.com/privacy/ads/">publicidad de Google Aviso de
            privacidad</a>  para obtener más información.
          </p>

          <p>
            Llevo a cabo acciones de remarketing mediante Facebook ads, que
            utiliza las cookies para ayudarnos a ofrecer anuncios en línea
            específico basado en visitas anteriores a mi sitio web.
          </p>

          <p>
            Cookies de Stripe y Paypal. Refuerzan la seguridad en el acceso a
            las plataforma de pagos que utilizamos. Pueden enlazar con
            paypalobjects.com.
          </p>

          <p>
            Cookies de Amazon: Utilizamos plataformas de servicios de afiliación
            que usan cookies de navegador para hacer seguimiento de las ventas
            que tuvieron origen en esta web en los programas de afiliados con
            los que esta web colabora.
          </p>

          <h5>Configuración de cookies para los navegadores más populares</h5>

          <p>
            A continuación te indicamos cómo acceder a una cookie determinada
            del navegador Chrome. Nota: estos pasos pueden variar en función de
            la versión del navegador:
          </p>

          <ol>
            <li>
              Ve a Configuración o Preferencias mediante el menú Archivo o bien
              pinchando el icono de personalización que aparece arriba a la
              derecha.
            </li>
            <li>
              Verás diferentes secciones, pincha la opción Mostrar opciones
              avanzadas.
            </li>
            <li>Ve a Privacidad, Configuración de contenido.</li>
            <li>Selecciona Todas las cookies y los datos de sitios.</li>
            <li>
              Aparecerá un listado con todas las cookies ordenadas por dominio.
              Para que te sea más fácil encontrar las cookies de un determinado
              dominio introduzca parcial o totalmente la dirección en el campo
              Buscar cookies.
            </li>
            <li>
              Tras realizar este filtro aparecerán en pantalla una o varias
              líneas con las cookies de la web solicitada. Ahora sólo tienes que
              seleccionarla y pulsar la X para proceder a su eliminación.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador Internet
            Explorer sigue estos pasos (pueden variar en función de la versión
            del navegador):
          </p>

          <ol>
            <li>Ve a Herramientas, Opciones de Internet</li>
            <li>Haz clic en Privacidad.</li>
            <li>
              Mueve el deslizador hasta ajustar el nivel de privacidad que
              desees.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador Firefox
            sigue estos pasos (pueden variar en función de la versión del
            navegador):
          </p>

          <ol>
            <li>Ve a Opciones o Preferencias según tu sistema operativo.</li>
            <li>Haz clic en Privacidad.</li>
            <li>
              En Historial elige Usar una configuración personalizada para el
              historial.
            </li>
            <li>
              Ahora verás la opción Aceptar cookies, puedes activarla o
              desactivarla según tus preferencias.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador Safari para
            OSX sigue estos pasos (pueden variar en función de la versión del
            navegador):
          </p>

          <ol>
            <li>Ve a Preferencias, luego Privacidad.</li>
            <li>
              En este lugar verás la opción Bloquear cookies para que ajuste el
              tipo de bloqueo que deseas realizar.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador Safari para
            iOS sigue estos pasos (pueden variar en función de la versión del
            navegador):
          </p>

          <ol>
            <li>Ve a Ajustes, luego Safari.</li>
            <li>
              Ve a Privacidad y Seguridad, verás la opción Bloquear cookies para
              que ajuste el tipo de bloqueo que deseas realizar.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador para
            dispositivos Android sigue estos pasos (pueden variar en función de
            la versión del navegador):
          </p>

          <ol>
            <li>Ejecuta el navegador y pulsa la tecla Menú, luego Ajustes.</li>
            <li>
              Ve a Seguridad y Privacidad, verás la opción Aceptar cookies para
              que active o desactive la casilla.
            </li>
          </ol>

          <p>
            Para acceder a la configuración de cookies del navegador para
            dispositivos Windows Phone sigue estos pasos (pueden variar en
            función de la versión del navegador):
          </p>

          <ol>
            <li>Abre Internet Explorer, luego Más, luego Configuración</li>
            <li>
              Ahora puedes activar o desactivar la casilla Permitir cookies.
            </li>
          </ol>

          <h5>Notas adicionales</h5>

          <ul>
            <li>
              Ni esta web ni sus representantes legales se hacen responsables ni
              del contenido ni de la veracidad de las políticas de privacidad
              que puedan tener los terceros mencionados en esta política de
              cookies.
            </li>
            <li>
              Los navegadores web son las herramientas encargadas de almacenar
              las cookies y desde este lugar debe efectuar su derecho a
              eliminación o desactivación de las mismas. Ni esta web ni sus
              representantes legales pueden garantizar la correcta o incorrecta
              manipulación de las cookies por parte de los mencionados
              navegadores.
            </li>
            <li>
              En algunos casos es necesario instalar cookies para que el
              navegador no olvide tu decisión de no aceptación de las mismas.
            </li>
            <li>
              En el caso de las cookies de Google Analytics, esta empresa
              almacena las cookies en servidores ubicados en Estados Unidos y se
              compromete a no compartirla con terceros, excepto en los casos en
              los que sea necesario para el funcionamiento del sistema o cuando
              la ley obligue a tal efecto. Según Google no guarda su dirección
              IP. Google Inc. es una compañía adherida al Acuerdo de Puerto
              Seguro que garantiza que todos los datos transferidos serán
              tratados con un nivel de protección acorde a la normativa europea.
            </li>
            <li>
              Para cualquier duda o consulta acerca de esta política de cookies
              no dudes en comunicarte con nosotros a través de la sección de
              contacto.
            </li>
            <li>
              Puedes consultar el reglamento sobre cookies publicado por la
              Agencia Española de Protección de Datos en su “Guía sobre el uso
              de las cookies” y obtener más información sobre las cookies en
              Internet, http://www.aboutcookies.org/
            </li>
          </ul>

          <h5>Aceptación de la política de cookies</h5>

          <p>
            Pulsando el botón de aceptación se asume que aceptas el uso de
            cookies.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Cookies",
  data() {
    return {
      email: "",
      password: "",
    };
  },
};
</script>
<style>
</style>